module.exports = __webpack_public_path__ + "static/img/downloadImg.b540a52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/downloadImg.svg
// module id = 22DX
// module chunks = 66